import React, { useState, useEffect } from 'react';

/**
 * GDPR-compliant cookie consent banner.
 * 
 * Shows banner only if user hasn't made a choice.
 * Allows users to accept or reject optional cookies (analytics, marketing).
 * Essential cookies are always active and don't require consent.
 */
const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consentStatus = localStorage.getItem('cookieConsent');
    // Only show if user hasn't made a choice
    if (!consentStatus) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    localStorage.setItem('cookiesAccepted', 'true'); // backward compatibility
    setShowBanner(false);
    
    // Initialize analytics after consent
    initializeAnalytics();
  };

  const handleReject = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    localStorage.removeItem('cookiesAccepted');
    setShowBanner(false);
    
    // Disable any running analytics
    disableAnalytics();
  };

  const initializeAnalytics = () => {
    // Load Google Analytics script if not already loaded
    if (!document.querySelector('script[src*="googletagmanager.com/gtag"]')) {
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.googletagmanager.com/gtag/js?id=G-GLE264E1QW';
      document.head.appendChild(script);
      
      script.onload = () => {
        window.dataLayer = window.dataLayer || [];
        function gtag(){window.dataLayer.push(arguments);}
        window.gtag = gtag;
        gtag('js', new Date());
        gtag('config', 'G-GLE264E1QW');
        console.log('[CookieConsent] Analytics initialized');
      };
    } else if (window.gtag) {
      // Re-enable if script exists
      window.gtag('consent', 'update', {
        analytics_storage: 'granted',
        ad_storage: 'granted'
      });
    }
  };

  const disableAnalytics = () => {
    // Disable Google Analytics
    if (window.gtag) {
      window.gtag('consent', 'update', {
        analytics_storage: 'denied',
        ad_storage: 'denied'
      });
    }
    
    // Set do-not-track flag
    window['ga-disable-G-GLE264E1QW'] = true;
    console.log('[CookieConsent] Analytics disabled');
  };

  return (
    showBanner && (
      <div className="cookie-wrapper" aria-live="polite" aria-atomic="true">
        <div className="cookie-text" role="dialog">
          <span id="cookie-consent-description">
            We use cookies to enhance your experience.{' '}
            <a
              href="/legal/?view=cookies-policy"
              target="_blank"
              rel="noopener noreferrer"
              className="learn-more-title"
              aria-label="Learn more about our cookie policy"
            >
              Learn more
            </a>
          </span>
        </div>
        <div className="cookie-buttons">
          <button 
            onClick={handleReject} 
            className='reject-cookie-btn' 
            aria-label="Reject optional cookies"
          >
            Reject
          </button>
          <button 
            onClick={handleAccept} 
            className='accept-cookie-btn' 
            aria-label="Accept all cookies"
          >
            Accept All
          </button>
        </div>
      </div>
    )
  );
};

export default CookieConsent;
